export default "__VITE_ASSET__4153b9c4__"